function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

require('xps-style/core/switch.css');

var propTypes = {
  /** id to be used by label component */
  id: PropTypes.string,

  /** Pass the id of an external label component so that the switch is labelled by your label id correctly */
  ariaLabelledBy: PropTypes.string,

  /** on state of the switch (default is false) */
  isOn: PropTypes.bool,

  /** callback function when switch button is clicked */
  onChange: PropTypes.func,

  /** position for state label (ON/OFF). Default is right */
  stateTextPosition: PropTypes.oneOf(['left', 'right', 'none']),

  /** text to display for on state. Default is "ON" */
  onText: PropTypes.string,

  /** text to display for off state. Default is "OFF" */
  offText: PropTypes.string
};
var defaultProps = {
  onChange: function onChange() {},
  isOn: false,
  stateTextPosition: 'right',
  onText: 'ON',
  offText: 'OFF'
};

var Switch = function Switch(_ref) {
  var id = _ref.id,
      ariaLabelledBy = _ref.ariaLabelledBy,
      isOn = _ref.isOn,
      onChange = _ref.onChange,
      stateTextPosition = _ref.stateTextPosition,
      onText = _ref.onText,
      offText = _ref.offText;

  var _useState = useState(isOn),
      _useState2 = _slicedToArray(_useState, 2),
      isOnState = _useState2[0],
      setIsOn = _useState2[1];

  var isOnStartingClassName = isOnState ? 'switch--start-on' : 'switch--start-off';
  var switchContainerIsOnClassName = isOnState ? 'switch-container--on' : 'switch-container--off';
  var switchIsOnClassName = isOnState ? 'switch--on' : 'switch--off';
  useEffect(function () {
    setIsOn(isOn);
  }, [isOn]);

  var onClick = function onClick() {
    setIsOn(function (prevIsOn) {
      var nextIsOn = !prevIsOn;
      onChange && onChange(nextIsOn);
      return nextIsOn;
    });
  };

  var renderState = function renderState() {
    var marginClass = stateTextPosition === 'left' ? 'marginright-md' : 'marginleft-md';
    return /*#__PURE__*/React.createElement("span", {
      role: "presentation",
      className: "".concat(marginClass, " fontweight-500 font-sm letterspacing-md")
    }, isOnState ? onText : offText);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "display-flex align-items-center"
  }, stateTextPosition === 'left' && renderState(), /*#__PURE__*/React.createElement("button", {
    id: id,
    type: "button",
    role: "switch",
    "aria-checked": isOnState,
    "aria-labelledby": ariaLabelledBy,
    className: classnames('switch-container', switchContainerIsOnClassName),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('switch', isOnStartingClassName, switchIsOnClassName)
  })), stateTextPosition === 'right' && renderState());
};

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
Switch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Switch",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "callback function when switch button is clicked"
    },
    "isOn": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "on state of the switch (default is false)"
    },
    "stateTextPosition": {
      "defaultValue": {
        "value": "'right'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }]
      },
      "required": false,
      "description": "position for state label (ON/OFF). Default is right"
    },
    "onText": {
      "defaultValue": {
        "value": "'ON'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display for on state. Default is \"ON\""
    },
    "offText": {
      "defaultValue": {
        "value": "'OFF'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display for off state. Default is \"OFF\""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "id to be used by label component"
    },
    "ariaLabelledBy": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass the id of an external label component so that the switch is labelled by your label id correctly"
    }
  }
};
export default Switch;